module.exports = __webpack_public_path__ + "static/media/google-contact.34f31004.svg";